var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00369159 8.56392C0.00369159 7.29519 0.0104277 6.02594 6.44214e-05 4.75721C-0.00408091 4.27309 0.191786 3.93035 0.600101 3.68463C2.53286 2.52129 4.46303 1.35429 6.39268 0.18572C6.80359 -0.0631215 7.20309 -0.0610348 7.61296 0.186764C9.54987 1.3595 11.4883 2.53015 13.4268 3.70028C13.8165 3.93556 14.0009 4.27309 13.9999 4.7353C13.9947 7.28162 13.9988 9.82795 13.9963 12.3743C13.9952 13.3253 13.3268 13.9946 12.3796 13.9977C11.5593 14.0004 10.7396 13.9998 9.91932 13.9977C9.24778 13.9957 8.81511 13.5642 8.81304 12.8928C8.81045 11.9976 8.81304 11.1024 8.812 10.2072C8.81148 9.75804 8.62546 9.56502 8.18917 9.5645C7.39482 9.56293 6.60099 9.56293 5.80664 9.5645C5.38122 9.56554 5.1895 9.75804 5.18898 10.1853C5.18743 11.0805 5.1895 11.9757 5.18795 12.8709C5.18639 13.5653 4.76201 13.9962 4.077 13.9977C3.24845 13.9998 2.41938 14.0014 1.59084 13.9972C0.679899 13.9925 0.00731875 13.3149 0.00472792 12.3962C0.00110075 11.1191 0.00369159 9.84151 0.00369159 8.56392Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.58130a8a.svg";
export { ForwardRef as ReactComponent };